import { useEffect, useState } from 'react';
import queryString from "query-string";

import Base from '../../utils/base'

export default function ConfirmationModal(props) {
  var base = new Base()

  return (
    <div className="modal fade" id={props.modal_id != null ? props.modal_id : "confirmationModal"} data-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">{base.i18n.t('notice')}</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {base.i18n.t('confirmation')}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={() => props.on_cancel_click()}>{base.i18n.t('no')}</button>
            <button className="btn btn-danger" onClick={() => props.on_confirm_click()}>{base.i18n.t('yes')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
